import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=10505a1e&scoped=true"
import script from "./step5.vue?vue&type=script&lang=ts"
export * from "./step5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10505a1e",
  null
  
)

export default component.exports